import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Title, Fieldset, Button, Control, Field } from "rbx";
import { useMutation } from "react-apollo";
import { CREATE_PRODUCT_MUTATION } from "../../graphql/Products/Products.graphql";
import { ourToast as toast } from "../../utils";
import { useSystemCodes } from "../../utils/hooks";
import Loading from "../Loading";
import ProductForm from "./ProductForm";

const DEFAULT_STATE = {
  ProductCode: "",
  Description: "",
  ProductGroupRecIdRef: "",
  ProductCatgRecIdRef: "",
  UOMRecIdRef: "",
  HazmatCode: "",
  Active: true,
  Mandatory: false,
  Price: 0,
  Percentage: "",
  Note: "",
  CalcTypeRecIdRef: "",
  RevGLRecIdRef: "",
  ListOrder: ""
};

const AddProductForm = ({ onComplete }) => {
  const [inputs, setInputs] = useState({ ...DEFAULT_STATE });
  const [codes, setCodes] = useState(null);
  const { data: systemCodes } = useSystemCodes({
    Category_in: ["General Ledger", "Product"],
    CodeName_in: ["AcctType", "ProductCatg"]
  });

  useEffect(() => {
    if (!codes && Array.isArray(systemCodes)) {
      setCodes({
        revenue: systemCodes.find(c => c.CodeId === "R"),
        fee: systemCodes.find(
          c => c.CodeName === "ProductCatg" && c.CodeId === "FEE"
        ),
        sale: systemCodes.find(
          c => c.CodeName === "ProductCatg" && c.CodeId === "SALE"
        )
      });
    }
  }, [codes, systemCodes]);

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setInputs({ ...inputs, [e.target.name]: value });
  };
  const [createProduct, { loading }] = useMutation(CREATE_PRODUCT_MUTATION, {
    refetchQueries: ["ALL_PRODUCTS_QUERY"]
  });
  const handleSave = async e => {
    e.preventDefault();
    if (
      parseInt(inputs.ProductCatgRecIdRef) === codes.sale.RecId &&
      !parseInt(inputs.ProductGroupRecIdRef)
    ) {
      toast.error("Product Group is required");
    } else {
      try {
        await createProduct({
          variables: {
            data: {
              ...inputs,
              ListOrder: inputs.ListOrder
                ? parseInt(inputs.ListOrder, 10)
                : null,
              ProductGroupRecIdRef: inputs.ProductGroupRecIdRef
                ? parseInt(inputs.ProductGroupRecIdRef)
                : null,
              ProductCatgRecIdRef: inputs.ProductCatgRecIdRef
                ? parseInt(inputs.ProductCatgRecIdRef)
                : null,
              UOMRecIdRef: inputs.UOMRecIdRef
                ? parseInt(inputs.UOMRecIdRef)
                : null,
              Price: inputs.Price ? parseFloat(inputs.Price) : null,
              Percentage: inputs.Percentage
                ? parseFloat(inputs.Percentage)
                : null,
              CalcTypeRecIdRef: inputs.CalcTypeRecIdRef
                ? parseInt(inputs.CalcTypeRecIdRef)
                : null,
              RevGLRecIdRef: inputs.RevGLRecIdRef
                ? parseInt(inputs.RevGLRecIdRef)
                : null
            }
          }
        });
        toast.success("Product created successfully.");
        onComplete();
      } catch (err) {
        console.log(err.message);
      }
    }
  };

  if (!codes) return <Loading />;

  return (
    <form className="add-item-form" id="add-product-form" onSubmit={handleSave}>
      <Title>Add Product</Title>
      <Fieldset disabled={loading}>
        <ProductForm
          codeStates={codes}
          inputs={inputs}
          onChange={handleChange}
        />
        <hr />
        <Field kind="group">
          <Control>
            <Button color="primary" form="add-product-form" type="submit">
              Submit
            </Button>
          </Control>
          <Control>
            <Button type="button" onClick={onComplete}>
              Cancel
            </Button>
          </Control>
        </Field>
      </Fieldset>
    </form>
  );
};

AddProductForm.propTypes = {
  onComplete: PropTypes.func
};
export default AddProductForm;
